<template>
    <div>
        <div class="step-content select-bot">
            <v-layout column align-center>
                <v-radio-group v-model="typeOfScenario" row>
                    <v-radio
                        v-for="opt in scenarioOptions"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value"
                    />
                </v-radio-group>
                <div v-if="typeOfScenario==='bot'">
                    <v-layout column align-start>
                        <div class="label">{{ $f.tc('currentBot') }}</div>
                        <v-layout>
                            <div style="width: 250px">
                                <v-text-field
                                    disabled hide-details
                                    v-model="currentBotName"
                                    class="input-custom"
                                ></v-text-field>
                            </div>
                            <div class="btn-custom btn-checkout" @click="goToScenario(campaign.bot.id)">
                                <img src="/img/checkout-blue.svg" style="transform: scale(0.95); margin-right: 6px"
                                     alt="link-to-scenario"/>
                                {{ $f.tc('bot') }}
                            </div>
                            <div class="btn-custom btn-checkout" @click="goToNLP(campaign.bot.id)">
                                <img src="/img/checkout-blue.svg" style="transform: scale(0.95); margin-right: 6px"
                                     alt="link-to-nlp"/>
                                {{ $f.tc('nlp') }}
                            </div>
                        </v-layout>
                    </v-layout>
                    <v-layout column align-start style="margin-top: 12px">
                        <div class="label">{{ isAdmin() ? $f.tc('bot') : $f.tc('template') }}</div>
                        <v-form v-model="formValid" ref="form" @submit="submit">
                            <v-layout>
                                <div style="width: 250px">
                                    <v-autocomplete
                                        hide-details
                                        v-model="bot"
                                        :items="botList"
                                        :rules="formRules.required"
                                        class="input-custom"
                                    ></v-autocomplete>
                                </div>
                                <div class="btn-custom btn-checkout" @click="goToScenario(bot)">
                                    <img src="/img/checkout-blue.svg"
                                         style="transform: scale(0.95); margin-right: 6px" alt="link-to-scenario"/>
                                    {{ $f.tc('bot') }}
                                </div>
                                <div class="btn-custom btn-checkout" @click="goToNLP(bot)">
                                    <img src="/img/checkout-blue.svg"
                                         style="transform: scale(0.95); margin-right: 6px" alt="link-to-nlp"/>
                                    {{ $f.tc('nlp') }}
                                </div>
                            </v-layout>
                        </v-form>
                    </v-layout>
                </div>
                <div v-else-if="typeOfScenario==='tova'">
                    <v-layout column align-start>
                        <div class="label">{{ $f.tc('currentTovaAgent') }}</div>
                        <v-layout>
                            <div style="width: 250px">
                                <v-text-field
                                    disabled hide-details
                                    v-model="currentTovaAgentName"
                                    class="input-custom"
                                ></v-text-field>
                            </div>
                            <div class="btn-custom btn-checkout" @click="goToTovaAgent(campaign.tova_agent.id)">
                                <img src="/img/checkout-blue.svg" style="transform: scale(0.95); margin-right: 6px"
                                     alt="link-to-tova"/>
                                {{ $f.tc('tova') }}
                            </div>
                        </v-layout>
                    </v-layout>
                    <v-layout column align-start style="margin-top: 12px">
                        <div class="label">{{ isAdmin() ? $f.tc('tova') : $f.tc('template') }}</div>
                        <v-form v-model="formValid" ref="form" @submit="submit">
                            <v-layout>
                                <div style="width: 250px">
                                    <v-autocomplete
                                        hide-details
                                        v-model="tovaAgent"
                                        :items="tovaAgentList"
                                        :rules="formRules.required"
                                        class="input-custom"
                                    ></v-autocomplete>
                                </div>
                                <div class="btn-custom btn-checkout" @click="goToTovaAgent(tovaAgent)">
                                    <img src="/img/checkout-blue.svg"
                                         style="transform: scale(0.95); margin-right: 6px" alt="link-to-tova"/>
                                    {{ $f.tc('tova') }}
                                </div>
                            </v-layout>
                        </v-form>
                    </v-layout>
                </div>
                <div v-else-if="typeOfScenario==='agent'">
                    <v-layout column align-start>
                        <div class="label">{{ $f.tc('currentAgent') }}</div>
                        <v-layout>
                            <div style="width: 250px">
                                <v-text-field
                                    disabled hide-details
                                    v-model="currentVoiceAgent"
                                    class="input-custom"
                                ></v-text-field>
                            </div>
                        </v-layout>
                    </v-layout>
                    <v-layout column align-start>
                        <div class="label">{{ $f.tc('agent') }}</div>
                        <v-form v-model="formValid" ref="form" @submit="submit">
                            <v-layout>
                                <div style="width: 250px">
                                    <v-text-field
                                        hide-details
                                        v-model="voiceAgent"
                                        :rules="formRules.required"
                                        class="input-custom"
                                    ></v-text-field>
                                </div>
                            </v-layout>
                        </v-form>
                    </v-layout>
                </div>
                <div v-else-if="typeOfScenario==='flow'">
                    <v-layout column align-start>
                        <div class="label">{{ $f.tc('currentVoiceAgentMultiAgent') }}</div>
                        <v-layout>
                            <div style="width: 250px">
                                <v-text-field
                                    disabled hide-details
                                    v-model="currentFlow"
                                    class="input-custom"
                                ></v-text-field>
                            </div>
                        </v-layout>
                    </v-layout>
                    <v-layout column align-start>
                        <div class="label">{{ $f.tc('voiceAgentMultiAgent') }}</div>
                        <v-form v-model="formValid" ref="form" @submit="submit">
                            <v-layout>
                                <div style="width: 250px">
                                    <v-text-field
                                        hide-details
                                        v-model="flow"
                                        :rules="formRules.required"
                                        class="input-custom"
                                    ></v-text-field>
                                </div>
                            </v-layout>
                        </v-form>
                    </v-layout>
                </div>
            </v-layout>
        </div>
        <div class="step-actions">
            <div v-if="canGoBack" @click="goBack" class="btn-custom btn-back" dark>
                {{ backTitle || $f.tc('back') }}
            </div>
            <div @click="submit()" class="btn-custom">
                {{ nextTitle || $f.tc('next') }}
            </div>
            <div v-if="isEdit" @click="submit()" class="btn-custom">
                {{ $f.tc('save') }}
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import {mapState} from 'vuex'
import ScenarioService from "@/services/scenario.service";
import AgentService from "@/services/agent.service";
import CampaignService from "@/services/campaign.service";
import utils from "@/utils/utils";

export default {
    name: 'NewCampaignStep21',
    mixins: [FormMixin, RoleMixin],
    props: {
        next: Function,
        nextTitle: String,
        back: Function,
        canGoBack: Boolean,
        backTitle: String
    },
    data() {
        return {
            typeOfScenario: 'bot',
            // use bot
            scenarioList: [],
            botList: [],
            bot: '',
            currentBotName: '',
            // use tova agent
            tovaAgentList: [],
            tovaAgent: '',
            currentTovaAgentName: '',
            // use agent
            voiceAgent: '',
            currentVoiceAgent: '',
            // use workflow
            flow: '',
            currentFlow: '',
            defaultScriptGroup: []
        }
    },
    mounted() {
        this.getBotList()
        this.getTovaAgentList()
        this.getDefaultScriptGroup()
    },
    computed: {
        utils() {
            return utils
        },
        ...mapState({
            campaign: state => state.campaign.campaign,
            isEdit: state => state.campaign.isEdit
        }),
        scenarioOptions() {
            const opts = [{ label: 'Bot', value: 'bot' }]
            if (utils.enableTovaAgent()) {
                opts.push({ label: 'Tova agent', value: 'tova' })
            }
            if (utils.enableVoiceAgent()) {
                opts.push({ label: 'Agent', value: 'agent' })
                opts.push({ label: 'Multi-Agent', value: 'flow' })
            }
            return opts
        }
    },
    methods: {
        getBotList() {
            this.$appService.showLoading()
            ScenarioService.search({page: 1, page_size: 1000}).then(
                result => {
                    this.scenarioList = result.data.data
                    this.botList = this.scenarioList.map(item => ({text: item.name, value: item.id}))
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('nlp')
                }))
            ).finally(this.$appService.hideLoading)
        },
        getTovaAgentList() {
            this.$appService.showLoading()
            AgentService.CRUD.search({page: 1, page_size: 1000}).then(
                result => {
                    this.tovaAgentList = result.data.data.map(item => ({text: item.name, value: item.id}))
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('tova')
                }))
            ).finally(this.$appService.hideLoading)
        },
        getDefaultScriptGroup() {
            this.$appService.showLoading()
            CampaignService.getDefaultScript().then(
                result => {
                    this.defaultScriptGroup = result.data
                }
            ).finally(this.$appService.hideLoading)
        },
        submitValidForm() {
            this.$appService.showLoading()
            let model = {}
            let group = []
            switch (this.typeOfScenario) {
                case 'bot':
                    group = this.defaultScriptGroup.filter(item => item.type === 'bot').map(item => item.id)
                    model['bot'] = this.bot;
                    model['tova_agent'] = null;
                    model['agent_id'] = '';
                    model['flow_id'] = '';
                    break;
                case 'tova':
                    group = this.defaultScriptGroup.filter(item => item.type === 'tova').map(item => item.id)
                    model['bot'] = null;
                    model['tova_agent'] = this.tovaAgent;
                    model['agent_id'] = '';
                    model['flow_id'] = '';
                    break;
                case 'agent':
                    group = this.defaultScriptGroup.filter(item => item.type === 'agent').map(item => item.id)
                    model['bot'] = null;
                    model['tova_agent'] = null;
                    model['agent_id'] = this.voiceAgent;
                    model['flow_id'] = '';
                    break;
                case 'flow':
                    group = this.defaultScriptGroup.filter(item => item.type === 'agent').map(item => item.id)
                    model['bot'] = null;
                    model['tova_agent'] = null;
                    model['agent_id'] = '';
                    model['flow_id'] = this.flow;
                    break;
                default:
                    model['bot'] = null;
                    model['tova_agent'] = null;
                    model['agent_id'] = '';
                    model['flow_id'] = '';
                    break;
            }
            model['group_freeswitch_script_ids'] = group
            this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                campaign: this.campaign,
                model: model
            }).then(
                () => {
                    if (typeof this.next === 'function') {
                        this.next()
                    }
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('update'),
                    item: this.$t('campaign')
                }))
            ).finally(this.$appService.hideLoading)
        },
        goBack() {
            if (typeof this.back === 'function') {
                this.back()
            }
        },
        goToScenario(id) {
            window.open(this.$router.resolve(`/scenarios/${id}`).href)
        },
        goToNLP(scenarioId) {
            let bot = this.scenarioList.find(scenario => scenario.id === scenarioId)
            if (bot) {
                let botHost = process.env.VUE_APP_BOT_HOST || 'https://bot.fpt.ai'
                window.open(`${botHost}/bot/${bot.nlp.code}`)
            } else {
                this.$appService.toastError('You don not have permission to access this bot')
            }
        },
        goToTovaAgent(id) {
            window.open(this.$router.resolve(`/agents/${id}`).href)
        },
        goToVoiceAgent(id) {
            let agentHost = process.env.VUE_APP_AGENT_END_POINT
            window.open(`${agentHost}/agent/${id}`)
        },
        goToFlow(id) {
            let agentHost = process.env.VUE_APP_AGENT_END_POINT
            window.open(`${agentHost}/flow/${id}`)
        }
    },
    watch: {
        campaign: {
            immediate: true,
            handler: function () {
                // use bot
                if (this.campaign && this.campaign.bot) {
                    this.bot = this.campaign.bot.id
                    this.currentBotName = this.campaign.bot.name
                } else {
                    this.bot = ''
                    this.currentBotName = ''
                }
                // use tova agent
                if (this.campaign && this.campaign.tova_agent) {
                    this.tovaAgent = this.campaign.tova_agent.id
                    this.currentTovaAgentName = this.campaign.tova_agent.name
                    this.typeOfScenario = 'tova'
                } else {
                    this.tovaAgent = ''
                    this.currentTovaAgentName = ''
                }

                // use agent
                if (this.campaign && this.campaign.agent_id) {
                    this.voiceAgent = this.campaign.agent_id
                    this.currentVoiceAgent = this.campaign.agent_id
                    this.typeOfScenario = 'agent'
                } else {
                    this.voiceAgent = ''
                    this.currentVoiceAgent = ''
                }

                // use flow
                if (this.campaign && this.campaign.flow_id) {
                    this.flow = this.campaign.flow_id
                    this.currentFlow = this.campaign.flow_id
                    this.typeOfScenario = 'flow'
                } else {
                    this.flow = ''
                    this.currentFlow = ''
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
.select-bot {
    display: block;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    max-width: 500px;
}


.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.label {
    font-family: "open sans semi";
    margin-bottom: 6px;
    font-size: 13px;
}

.step-actions {
    .btn-custom {
        margin-left: 8px;

        &:first-child {
            margin-left: 0 !important;
        }
    }
}

.btn-checkout {
    background: #FFFFFF;
    border: 1px solid #0052CC;
    color: #0052cc;
    margin-left: 8px;

    &:hover {
        background: #d9e5f7;
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

@media screen and (min-width: 600px) {
    .select-bot {
        padding: 48px 0 52px;
    }
}
</style>
